import { api } from "./useApi";

export const caracteristicasApi = () => ({
  getCaracteristicas: async (): Promise<{ id: number; nome: string }[]> => {
    let response = await api.post("empresa/caracteristicasLista");
    return response.data;
  },
});
